import React from "react";
import { connect } from "react-redux";
import { Card, CardBody } from "reactstrap";

import moment from "moment";

import { toLower, startCase, debounce } from "lodash";
import { formValueSelector } from "redux-form";
import RouteAllowed from "../../../helper/isRouteAllowed";

import { TextClipper } from "../../../helper/TextFormatter";

import { PopOver, Tooltip } from "../../../core";
import { CardImageWithLoad } from "../../../helper/cardImageWithLoad";
import { CustomCheckBox } from "../../../helper/customCheckBox";

import ContentHeader from "./contentHeader";
import PhoneBreakpoint from "../../../context/phone_breakpoint";

// eslint-disable-next-line react/no-multi-comp
class GridContentView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { roles, permission } = this.props;
    return (
      <div>
        <ContentHeader
          forwardRef={this.props.searchRef}
          refreshing={this.props.refreshing}
          handleRefresh={this.props.handleRefresh}
          handleFilter={this.props.handleFilter}
          handleSearch={this.props.handleSearch}
          handleFilterWithType={this.props.handleFilterWithType}
          handleArchiveItems={this.props.handleArchiveItems}
          handleDeleteContents={this.props.handleDeleteContents}
          handleClearSearchValue={this.props.handleClearSearchValue}
          {...this.props}
        />
        <div className="screenShot_container">
          <div className="row">
            {" "}
            {this.props.contentList.length > 0 ? (
              this.props.contentList.map(item => (
                <div
                  className="col-xs-12
                    col-sm-8
                    col-md-6
                    col-lg-3"
                  key={item.id}
                >
                  <Card className="screenShot_container__screen">
                    <CardBody>
                      <div
                        role="presentation"
                        className="screenShot_container__imageWrapper"
                        onClick={e => {
                          e.stopPropagation();
                          return this.props.handleContentEditAndView(
                            true,
                            "view",
                            item
                          );
                        }}
                      >
                        <div>
                          <CardImageWithLoad
                            url={item.attributes.s3_thumbnail_large_url}
                          />
                        </div>
                        <PhoneBreakpoint>
                          <CustomCheckBox
                            item={item}
                            selectedList={this.props.contentsSelected}
                            form="SelectedContents"
                            formField="contentSelected"
                            change={this.props.change}
                          />
                        </PhoneBreakpoint>
                        <div
                          className="imageOverlay imageOverlay--mod"
                          style={{
                            bottom:
                              this.props.contentsSelected.filter(
                                i => i.id === item.id
                              ).length > 0 && 0
                          }}
                        >
                          <CustomCheckBox
                            item={item}
                            selectedList={this.props.contentsSelected}
                            form="SelectedContents"
                            formField="contentSelected"
                            change={this.props.change}
                          />
                          <div className="actionButtonWrapper actionButtonWrapper--mod">
                            <RouteAllowed
                              roles={roles && roles}
                              permission={
                                permission && permission.archive.content
                              }
                            >
                              <Tooltip
                                item={
                                  <i
                                    role="presentation"
                                    onClick={e => {
                                      e.stopPropagation();
                                      return this.props.handleArchiveItem(
                                        item.id,
                                        item.attributes.name
                                      );
                                    }}
                                    className="fa fa-archive"
                                  />
                                }
                                id={`archive-${item.id}`}
                                tooltipContent="Archive"
                              />
                            </RouteAllowed>
                            <RouteAllowed
                              roles={roles && roles}
                              permission={
                                permission && permission.content.delete
                              }
                            >
                              <Tooltip
                                item={
                                  <i
                                    role="presentation"
                                    onClick={e => {
                                      e.stopPropagation();
                                      return this.props.handleDelete(
                                        item.id,
                                        item.attributes.name
                                      );
                                    }}
                                    className="fa fa-trash"
                                  />
                                }
                                id={`delete-${item.id}`}
                                tooltipContent="Delete"
                              />
                            </RouteAllowed>
                          </div>
                          <div className="centerAlignedDiv">
                            <span>View Content</span>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex screenShot_container__textWrapper">
                        <div className="mr-auto screenShot_container__hostName">
                          {item.attributes.name &&
                          item.attributes.name.length >= 20 ? (
                            <Tooltip
                              item={
                                <span>
                                  {" "}
                                  {`${item.attributes.name.slice(
                                    0,
                                    20
                                  )}...`}{" "}
                                </span>
                              }
                              id={`viewname-${item.id}`}
                              tooltipContent={item.attributes.name}
                            />
                          ) : (
                            <span>{item.attributes.name}</span>
                          )}
                          {!item.attributes.name && <span>N/A</span>}
                        </div>
                        <div className="screenShot_container__buttonsWrapper">
                          <div className="contentTag">
                            <ul>
                              <li>
                                {item.attributes.tags &&
                                  item.attributes.tags
                                    .slice(0, 2)
                                    .map((i, index) => (
                                      <span
                                        key={`content-tag-${item.id} `}
                                        className="contentTag__badge"
                                      >
                                        {" "}
                                        {TextClipper(
                                          item.id,
                                          i,
                                          8,
                                          index,
                                          "tags",
                                          "contentTag__wrapper"
                                        )}
                                      </span>
                                    ))}
                                <span>
                                  {item.attributes.tags &&
                                    item.attributes.tags.length > 2 && (
                                      <PopOver id={`content-tag-${item.id}`}>
                                        {item.attributes.tags.map(i => (
                                          <span
                                            key={`content-tag-${item.id}`}
                                            className="contentTag__wrapper contentTag__badge"
                                          >
                                            {i}
                                          </span>
                                        ))}
                                      </PopOver>
                                    )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <span className="mr-auto" style={{ fontSize: "14px" }}>
                        {item.attributes.dimension || "N/A"} {` |   `}
                        {item.attributes.updated_at
                          ? `  Updated ${moment
                              .utc(item.attributes.updated_at)
                              .fromNow()}`
                          : "N/A"}{" "}
                      </span>
                      <div className="mt-1 d-block screenShot_container__buttonsWrapper">
                        <div className="contentTag">
                          <ul>
                            <li>
                              {item.attributes.sponsor_tags &&
                                item.attributes.sponsor_tags
                                  .slice(0, 3)
                                  .map((i, index) => (
                                    <span
                                      key={`content-sponsor-${item.id} `}
                                      className="contentTag__badge contentTag__badge--mod"
                                    >
                                      {" "}
                                      {TextClipper(
                                        item.id,
                                        i,
                                        8,
                                        index,
                                        "sponsers",
                                        "contentTag__wrapper"
                                      )}
                                    </span>
                                  ))}
                              <span>
                                {item.attributes.sponsor_tags &&
                                  item.attributes.sponsor_tags.length > 3 && (
                                    <PopOver id={`content-sponsor-${item.id}`}>
                                      {item.attributes.sponsor_tags.map(i => (
                                        <span
                                          key={`content-sponsor-${item.id} `}
                                          className="contentTag__wrapper contentTag__badge contentTag__badge--mod"
                                        >
                                          {i}
                                        </span>
                                      ))}
                                    </PopOver>
                                  )}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </CardBody>{" "}
                  </Card>{" "}
                </div>
              ))
            ) : (
              <span className="null-message-info">No Data</span>
            )}{" "}
          </div>
        </div>{" "}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const selector = formValueSelector("SelectedContents");

  return {
    contentsSelected: selector(state, "contentSelected") || []
  };
}
export default connect(mapStateToProps)(GridContentView);
